import { BehaviorSubject } from 'rxjs';
import CasClient, { constant } from "react-cas-client";

const APP_ID = process.env.REACT_APP_ID;
const API_URL = process.env.REACT_APP_API_URL;
const currentUser = {
    usuario: "",
    idpersona: 0,
    identificacion: "",
    ultimoCambio: "",
    apellidos: "",
    nombres: "",
    roles: [],
    token: ""
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authenticationService = {
    login,
    logout,
    fetch,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value },
};

function login(currentUser) {
    //let realFetch = window.fetch;
    //window.fetch = function (url, opts = null) {
    //    console.log(opts)
    //    const currentUser = currentUserSubject.value;
    //    console.log(currentUser);
    //    //console.log("*****using custom fetch url = " + url);
    //    if (currentUser.token) {
    //        console.log("ENTROO TOKEN");
    //        opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json', 'Authorization': `Bearer ${currentUser.token}` } });
    //        console.log(opts);
    //        return realFetch(url, opts);
    //    } else {
    //        //console.log("[fetch] url: " + url + " opts: " + JSON.stringify(opts));
    //        return realFetch(url, opts);
    //    }
    //};
    currentUserSubject.next(currentUser);
    //console.log("login update currentUser = " + JSON.stringify(currentUser));
}

function logout() {
    // remove user and go to logout CAS
    currentUserSubject.next(null);
    window.location.href = "/Account/Logout";
}

function fetch() {
    let realFetch = window.fetch;
    window.fetch = function (url, opts = null) {
        const currentUser = currentUserSubject.value;
        //console.log(currentUser);
        //console.log("*****using custom fetch url = " + url);
        if (currentUser.token) {
            //console.log("ENTROO TOKEN");
            opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json', 'Authorization': `Bearer ${currentUser.token}` } });
            //console.log(opts);
            return realFetch(url, opts);
        } else {
            //console.log("[fetch] url: " + url + " opts: " + JSON.stringify(opts));
            return realFetch(url, opts);
        }
    };
}